module.exports = __webpack_public_path__ + "img/crew_adv_11.09ebb1ce.png";